export default __webpack_public_path__ + "static/media/acs01.cacaa682.svg";